import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { IMAGES } from "../data/content";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminDashboard } from "../components/admin/AdminDashboard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const adminApi = axios.create({ baseURL: API, withCredentials: true });

export default function Segreteria() {
  const [user, setUser] = useState(null); // null = verifica, false = non autenticato

  useEffect(() => {
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    await adminApi.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <div data-testid="segreteria-page" className="min-h-screen bg-neutral-950 text-neutral-100 flex flex-col">
      <header className="border-b border-neutral-800 h-16 flex items-center justify-between px-4 sm:px-8">
        <Link to="/" className="flex items-center gap-3">
          <span className="w-3 h-3 bg-red-600 inline-block" />
          <img src={IMAGES.logoWhite} alt="Legend Team" className="h-6 w-auto" />
          <span className="hidden sm:inline mono-label text-xs uppercase tracking-wider text-neutral-500 border-l border-neutral-800 pl-3">
            Area Segreteria
          </span>
        </Link>
        {user && (
          <div className="flex items-center gap-4">
            <span className="hidden sm:inline-flex items-center gap-2 mono-label text-xs text-neutral-400">
              <ShieldCheck className="w-4 h-4 text-red-500" /> {user.email}
            </span>
            <button
              type="button"
              data-testid="admin-logout"
              onClick={logout}
              className="inline-flex items-center gap-2 px-3 py-2 border border-neutral-700 hover:border-red-600 text-xs font-bold uppercase tracking-widest text-neutral-200 hover:text-red-500 transition-colors"
            >
              <LogOut className="w-4 h-4" /> Esci
            </button>
          </div>
        )}
      </header>
      <main className="flex-1">
        {user === null && (
          <p data-testid="admin-loading" className="p-10 mono-label text-xs text-neutral-500 uppercase">Verifica sessione...</p>
        )}
        {user === false && <AdminLogin onLogin={setUser} />}
        {user && <AdminDashboard />}
      </main>
    </div>
  );
}
